import { render } from "./SatellitesPerBaseStationChartGroup.vue?vue&type=template&id=fc3c21ac"
import script from "./SatellitesPerBaseStationChartGroup.vue?vue&type=script&lang=js"
export * from "./SatellitesPerBaseStationChartGroup.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__